import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import dataFetcher from "../../../parts/chore/dataFetcher";

import { checkAuthorization } from 'Parts/common/authorizationUtils';

import CampaignsSettingsTransactionsPage from './CampaignsSettingsTransactionsPage';

const mapStateToProps = state => ({
  permissions: state.session.permissions,
  platform: state.platform.platform,
  campaign: state.campaign.campaign,
  campaigns: state.campaign.campaigns,
  locale: state.session.language,
  organization: state.organization.organization
});

const mapDispatchToProps = dispatch => bindActionCreators({
  checkAuthorization
 }, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  dataFetcher
)(CampaignsSettingsTransactionsPage);
